import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";

const CtaBand = ({
  title = "Pronto a valorizzare i tuoi crediti?",
  text = "Il nostro team è a disposizione per analizzare le tue esigenze e proporti soluzioni su misura, con la massima riservatezza.",
  primaryLabel = "Richiedi una consulenza",
  tone = "navy",
}) => {
  const isGold = tone === "gold";
  return (
    <section data-testid="cta-band" className={`relative overflow-hidden ${isGold ? "bg-gold" : "bg-navy"}`}>
      {!isGold && (
        <>
          <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-40 -left-24 h-96 w-96 rounded-full bg-gold/5 blur-3xl" />
        </>
      )}
      <div className="relative mx-auto max-w-5xl px-6 py-24 text-center lg:py-28">
        <Reveal>
          <h2 className={`font-display text-4xl leading-[1.08] sm:text-5xl lg:text-6xl ${isGold ? "text-navy" : "text-white"}`}>
            {title}
          </h2>
          <p className={`mx-auto mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${isGold ? "text-navy/70" : "text-white/60"}`}>
            {text}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to="/contatti"
              data-testid="cta-band-primary"
              className={`group inline-flex items-center gap-2 rounded-full px-8 py-3.5 text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5 ${
                isGold
                  ? "bg-navy text-white shadow-xl shadow-navy/25 hover:bg-navy-light"
                  : "bg-gold text-navy shadow-xl shadow-gold/25 hover:bg-gold-light"
              }`}
            >
              {primaryLabel}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/servizi"
              data-testid="cta-band-secondary"
              className={`inline-flex items-center gap-2 rounded-full border px-8 py-3.5 text-sm font-semibold transition-all duration-300 ${
                isGold
                  ? "border-navy/30 text-navy hover:border-navy hover:bg-navy/5"
                  : "border-white/25 text-white hover:border-gold hover:text-gold"
              }`}
            >
              <Phone size={15} />
              Scopri i servizi
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBand;
